import Modal from 'bootstrap/js/dist/modal.js';

import { getSelector, i18n, moneyFormat } from '../utils.js';

let _inProgress = false,
      _indexUrl,
      _showLowerMinOrderValue,
      _imgBase = 'https://static.medi-king.de/images/products',
      _cartI18n = {};

  export function setI18n(messageObject) {
    // _cartI18n = messageObject;
  }

  export const add = (e, jqObject) => {
    e.preventDefault();

    const $form = jqObject !== undefined ? jqObject : $(e.target);
    const url = $form.attr('action');
    const data = $form.serialize();

    $.ajax({
      type: 'POST',
      url: `${url}?format=json`,
      data: data,
      success: (data) => addSuccess($form, data),
      error: addError
    });

    return false;
  }

  export const addToWishList = (e) => {
    e.preventDefault();

    const $form = getSelector(arguments, e.target);
    const url = $form.attr('action');
    const data = $form.serialize();

    $.ajax({
      type: 'POST',
      url: `${url}?format=json`,
      data: data,
      success: (data) => addToWishListSuccess(data),
      error: addError
    });

    return false;
  }

  const addSuccess = ($form, data) => {
    let addedItems = [];
    let formArray = $form.serializeArray();
    for (var i = 0; i < formArray.length; i++) {
      if(!formArray[i].name.startsWith('items.')) {
        continue;
      }

      var id = formArray[i].name.substring(6);
      var quantity = parseInt(formArray[i].value);
      for (var j = 0; j < data['shoppingCart']['items'].length; j++) {
        if(data['shoppingCart']['items'][j].id === id) {
          var item = Object.assign({}, data['shoppingCart']['items'][j]);
          if(item.quantity >= quantity) {
            item.status = 'success';
            item.quantity = quantity;
            addedItems.push(item);
          }
        }
      }
    }

    let message = addedItems.length > 0 ? i18n('cart.added.headline') : i18n('cart.added.error');

    const renderAddedItem = (item) => (
      `<article class="product-item">
          <div class="product-image">
            <img src="${_imgBase}/list/${(item.imageFilename ? item.imageFilename : 'default.jpg')}" alt="${item.productName}" />
          </div>
          <div class="product-main">
            <h1 class="name">${item.productName}</h1>
            <div>${i18n('cart.item.quantity')}: ${item.quantity ? item.quantity : '-'}</div>
            <div class="price mt-1">
              <div class="price-sale">
                ${moneyFormat(item.salePriceIncludingTax.amount)}*
              </div>
              <div class="price-net">
                ${i18n('product.price.net')}: ${moneyFormat(item.salePriceBeforeTax.amount)}
              </div>
              <p class="mt-1">* inkl. MwSt. und zzgl. <a href="/versandkosten">Versandkosten</a></p>
            </div>
          </div>
        </article>`
    );

    const renderAddedItems = (items) => {
      if (items.length > 0) {
        return items.map( (item) => renderAddedItem(item) ).join('');
      }

      return `cart.added.none`;
    };

    const modal = `
      <div class="modal fade">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">${message}</h3>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              ${renderAddedItems(addedItems)}
            </div>
            <div class="modal-footer d-flex justify-content-between">
              <button class="btn btn-secondary" data-bs-dismiss="modal">${i18n('continue.shopping')}</button>
              <div class="text-end">
                <a href="/cart" class="btn btn-primary">${i18n('shoppingCart.cart')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    const $modal = $(modal);
    $('body').append($modal);
    new Modal($modal[0]).show();

    updateSmallCart(data['shoppingCart']);
  }

  const addToWishListSuccess = (data) => {
    let message = data['addedProducts'].length > 0 ? i18n('wishList.added.headline') : i18n('wishList.added.error');

    const renderAddedItem = (item) => (
      `
        <article class="product-item">
          <div class="product-image">
            <img src="${_imgBase}/list/${(item.product.images[0] ? item.product.images[0] : 'default.jpg')}" alt="${item.product.name}" />
          </div>
          <div class="product-main">
            <h1 class="name">${item.product.name}</h1>
          </div>
        </article>
      `
    );

    const renderAddedItems = (items) => {
      if (items.length > 0) {
        return items.map( (item) => renderAddedItem(item) ).join('');
      }

      return `cart.added.none`;
    };

    const modal = `
      <div class="modal fade">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h3 class="modal-title">${message}</h3>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              ${renderAddedItems(data['addedProducts'])}
            </div>
            <div class="modal-footer d-flex justify-content-between">
              <button class="btn btn-secondary" data-bs-dismiss="modal">${i18n('continue.shopping')}</button>
              <div class="text-end">
                <a href="/wishList/index" class="btn btn-primary">${i18n('wishList.added.view')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    const $modal = $(modal);
    $('body').append($modal);
    new Modal($modal[0]).show();
  }

  function addError(response) {
    console.log(response)
  }

  export const updateSmallCart = (cart) => {
    const $smallCart = $('.smallCart'),
          $smallCartCount = $smallCart.find('.count-items'),
          $mobileSmallCartTrigger = $('.cart-trigger'),
          $smallCartTotal = $smallCart.find('.price');

    $smallCart.find('.js-smallCart-checkout').toggleClass('disabled', (cart.items.length === 0));
    $smallCartCount.html(parseInt(cart.items.length, 10));
    $mobileSmallCartTrigger.attr('data-count', parseInt(cart.items.length, 10));
    $smallCartTotal.html(moneyFormat(cart.subTotal.amount));
  }

  export function init(indexUrl, showLowerMinOrderValue) {
    _indexUrl = indexUrl;
    _showLowerMinOrderValue = showLowerMinOrderValue;
  }



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/modules/shoppingCart.js